module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "map-center.1f48b751.svg";